import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { currentUserStore } from '../../../../CurrentUserStore';
import { emptyFragment } from '../../../../EmptyFragment';
import { findLink } from '../../../../LinkyLinky';
import { T } from '../../../../Translations';

/**
 * Same gating as the current page: the V2 importer when available, otherwise
 * V1. PlatformRouter mounts whichever one the link allows at this path.
 */
function ImportLink() {
  return findLink('import-multiple-participants', currentUserStore.links)
    .orElse(() => findLink('import-participants', currentUserStore.links))
    .map(() => (
      <Link
        to="/people/import_participants"
        className="flex flex-shrink-0 items-center rounded-md border border-primary bg-card px-5 py-2.5 text-primary transition-opacity hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-ring"
        style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
        data-intercom-target="people-v2-import-participants-button"
      >
        <T kind="Import participants" />
      </Link>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ImportLink);
